import { Button, Stack } from '@mui/material';
import { DocumentType, graphql } from '../../../../../gql';
import { useEditModal } from '../../../../../modal/useEditModal';
import { PersonaEdit } from '../../../../../persona/list/PersonaEdit';
import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { z } from 'zod';
import { PersonaDrawerRow } from './PersonaDrawerRow';
import { useApiQuery } from '../../../../../query/hooks';
import { DrawerHeader } from '../../../../../drawer/DrawerHeader';
import { useNavigate } from 'react-router';
import { DrawerWrapper } from '../../../../../drawer/DrawerWrapper';

const activityPersonaQuery = graphql(`
	query journeyDetail_listActivityPersonas($activityId: UUID!) {
		activityPersonas: getActivity(by: { id: $activityId }) {
			personas {
				id
				name
				...PersonaAvatar_persona
			}
		}
		listPersona {
			id
			name
			...PersonaAvatar_persona
		}
	}
`);

export type DrawerPersona = DocumentType<typeof activityPersonaQuery>['listPersona'][number];

export const personasEditDrawerSchema = z.object({
	activityId: z.string(),
});

export const PersonasEditDrawer: FC<z.infer<typeof personasEditDrawerSchema>> = ({ activityId }) => {
	const { data: personas } = useApiQuery(activityPersonaQuery, { variables: { activityId } });
	const intl = useIntl();
	const navigate = useNavigate();
	const { state, close } = useEditModal<{ id: string; name: string }>();

	if (!personas) {
		return null;
	}

	const { activityPersonas, listPersona } = personas;

	return (
		<DrawerWrapper>
			<DrawerHeader title={intl.formatMessage({ id: 'journey.detail.widget.personas.title' })} />
			{listPersona.length > 0 && (
				<Stack direction={'column'} gap={3} width={'100%'}>
					{listPersona.map((persona) => {
						const isAddedToActivity = Boolean(activityPersonas?.personas.find((p) => p.id === persona.id));
						return <PersonaDrawerRow {...persona} isAddedToActivity={isAddedToActivity} activityId={activityId} />;
					})}
				</Stack>
			)}

			<Button variant={'contained'} onClick={() => navigate('/personas')} color={'secondary'} sx={{ marginTop: '32px' }}>
				<FormattedMessage id={'personas.create'} />
			</Button>
			<PersonaEdit state={state} onSave={() => close()} onCancel={() => close()} />
		</DrawerWrapper>
	);
};
